<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="18">
        <el-card shadow="never" :body-style="{'padding': '10px'}">
          <template slot="header">
            <span class="theme size16">热门交易</span>
          </template>

          <ul class="trade-list small clearfix">
            <li class="trade-item clearfix" v-for="(item, idx) in hotTradeList" :key="idx">
              <router-link :to="item.id" :title="item.title" class="img pull-left">
                <img :src="item.image" :alt="item.title">
              </router-link>

              <div class="meta pull-left">
                <router-link :to="item.id" :title="item.title" class="title">
                  {{ item.title }}
                  <span class="theme price">{{ item.price }}</span>
                </router-link>
                <div class="desc">{{ item.desc }}</div>
                <div class="time">{{ item.time }}</div>
              </div>

              <div class="button pull-right">
                <router-link class="link" :to="item.id" :title="item.title">查看详情</router-link>
              </div>
            </li>
          </ul>
        </el-card>

        <el-card shadow="never" class="mt10" :body-style="{'padding': '10px'}">
          <template slot="header">
            <span class="theme size16">最新交易</span>
          </template>

          <ul class="trade-list border clearfix">
            <li class="trade-item clearfix" v-for="(item, idx) in newTradeList" :key="idx">
              <router-link :to="item.id + '?type=1'" :title="item.title" class="img pull-left">
                <img :src="item.image" :alt="item.title">
              </router-link>

              <div class="meta pull-left">
                <router-link :to="item.id + '?type=1'" :title="item.title" class="title">
                  {{ item.title }}
                  <span class="theme price">{{ item.price }}</span>
                </router-link>
                <div class="desc">{{ item.desc }}</div>
                <div class="time">{{ item.time }}</div>
              </div>

              <div class="button pull-right">
                <router-link class="link" :to="item.id + '?type=1'" :title="item.title">查看详情</router-link>
              </div>
            </li>
          </ul>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card shadow="never">
          <template slot="header">
            <span class="theme size16">最新开服</span>
          </template>

          <hot-list />
        </el-card>

        <el-card shadow="never" class="mt10">
          <template slot="header">
            <span class="theme size16">相关资讯</span>
          </template>

          <list />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      hotTradeList: this.$datas.hotTradeList,
      newTradeList: this.$datas.newTradeList,
    }
  }
}
</script>

<style lang="scss">

</style>
